import { render, staticRenderFns } from "./experimentTeaView.vue?vue&type=template&id=45058f0d&scoped=true"
import script from "./experimentTeaView.vue?vue&type=script&lang=js"
export * from "./experimentTeaView.vue?vue&type=script&lang=js"
import style0 from "./experimentTeaView.vue?vue&type=style&index=0&id=45058f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45058f0d",
  null
  
)

export default component.exports